import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import "./Navbar.css";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

// Import only ProfileMenu component
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

const Navbar = props => {

  const [dashboard, setdashboard] = useState(false);
  const [ui, setui] = useState(false);
  const [app, setapp] = useState(false);
  const [email, setemail] = useState(false);
  const [ecommerce, setecommerce] = useState(false);
  const [crypto, setcrypto] = useState(false);
  const [project, setproject] = useState(false);
  const [task, settask] = useState(false);
  const [contact, setcontact] = useState(false);
  const [blog, setBlog] = useState(false);
  const [job, setJob] = useState(false);
  const [candidate, setCandidate] = useState(false);
  const [component, setcomponent] = useState(false);
  const [form, setform] = useState(false);
  const [table, settable] = useState(false);
  const [chart, setchart] = useState(false);
  const [icon, seticon] = useState(false);
  const [map, setmap] = useState(false);
  const [extra, setextra] = useState(false);
  const [invoice, setinvoice] = useState(false);
  const [auth, setauth] = useState(false);
  const [utility, setutility] = useState(false);
  const [transaction, settransaction] = useState(false);
  const [tools, settools] = useState(false);
  const [approveordes, setapproveordes] = useState(false);
  const [reports, setreports] = useState(false);

  // Timeout references for delayed dropdown closing
  const [dashboardTimeout, setDashboardTimeout] = useState(null);
  const [uiTimeout, setUiTimeout] = useState(null);
  const [transactionTimeout, setTransactionTimeout] = useState(null);
  const [toolsTimeout, setToolsTimeout] = useState(null);
  const [approveordesTimeout, setApproveordesTimeout] = useState(null);
  const [reportsTimeout, setReportsTimeout] = useState(null);
  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  // Helper functions for delayed dropdown closing
  const openDropdown = (setter, timeoutRef, setterRef) => {
    if (timeoutRef) clearTimeout(timeoutRef);
    setter(true);
  };

  const closeDropdown = (setter, timeoutRef, setterRef, delay = 300) => {
    const timeout = setTimeout(() => {
      setter(false);
    }, delay);
    setterRef(timeout);
  };

  // Function to close all dropdowns immediately
  const closeAllDropdowns = () => {
    setdashboard(false);
    setui(false);
    setapp(false);
    setemail(false);
    setecommerce(false);
    setcrypto(false);
    setproject(false);
    settask(false);
    setcontact(false);
    setBlog(false);
    setJob(false);
    setCandidate(false);
    setcomponent(false);
    setform(false);
    settable(false);
    setchart(false);
    seticon(false);
    setmap(false);
    setextra(false);
    setinvoice(false);
    setauth(false);
    setutility(false);
    settransaction(false);
    settools(false);
    setapproveordes(false);
    setreports(false);
    
    // Clear all timeouts
    if (dashboardTimeout) clearTimeout(dashboardTimeout);
    if (uiTimeout) clearTimeout(uiTimeout);
    if (transactionTimeout) clearTimeout(transactionTimeout);
    if (toolsTimeout) clearTimeout(toolsTimeout);
    if (approveordesTimeout) clearTimeout(approveordesTimeout);
    if (reportsTimeout) clearTimeout(reportsTimeout);
  };

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (dashboardTimeout) clearTimeout(dashboardTimeout);
      if (uiTimeout) clearTimeout(uiTimeout);
      if (transactionTimeout) clearTimeout(transactionTimeout);
      if (toolsTimeout) clearTimeout(toolsTimeout);
      if (approveordesTimeout) clearTimeout(approveordesTimeout);
      if (reportsTimeout) clearTimeout(reportsTimeout);
    };
  }, [dashboardTimeout, uiTimeout, transactionTimeout, toolsTimeout, approveordesTimeout, reportsTimeout]);

  return (
  
    <React.Fragment>
      <div className="topnav" style={{ marginTop: "0" }}>
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            {/* Brand/Logo Section */}
            <div className="navbar-brand-custom d-flex align-items-center">
              <i className="bx bx-cube me-2 brand-icon"></i>
              <span className="brand-text">KirayaGo </span>
            </div>

            <Collapse
              isOpen={true}
              className="navbar-collapse"
              id="topnav-menu-content"
              navbar
            >
              <ul className="navbar-nav">

                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setdashboard, dashboardTimeout, setDashboardTimeout)}
                  onMouseLeave={() => closeDropdown(setdashboard, dashboardTimeout, setDashboardTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/dashboard"
                  >
                    <i className="bx bx-home-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Dashboard")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: dashboard })}
                    onMouseEnter={() => openDropdown(setdashboard, dashboardTimeout, setDashboardTimeout)}
                    onMouseLeave={() => closeDropdown(setdashboard, dashboardTimeout, setDashboardTimeout)}
                  >
                    <Link to="/dashboard" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-tachometer me-2"></i>
                      {props.t("Default")}
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setui, uiTimeout, setUiTimeout)}
                  onMouseLeave={() => closeDropdown(setui, uiTimeout, setUiTimeout)}
                >
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-cog me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Masters")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu dropdown-menu-left dropdown-mega-menu-xl",
                      { show: ui }
                    )}
                    onMouseEnter={() => openDropdown(setui, uiTimeout, setUiTimeout)}
                    onMouseLeave={() => closeDropdown(setui, uiTimeout, setUiTimeout)}
                  >
                    <Row>
                      <Col lg={12}>
                        <div className="p-3">
                          <h6 className="text-muted mb-3 text-uppercase font-weight-bold">
                            <i className="bx bx-category me-2"></i>
                            Master Data Management
                          </h6>
                          <div className="row">
                            <Link to="/UserMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-user-circle me-2 text-danger"></i>
                              {props.t("User Master")}
                            </Link>
                            <Link to="/MemberMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-user me-2 text-info"></i>
                              {props.t("Member Master")}
                            </Link>
                            <Link to="/VehicleTypeMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-car me-2 text-warning"></i>
                              {props.t("Vehicle Type Master")}
                            </Link>
                            {/* <Link to="/VehicleMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bxs-car me-2 text-danger"></i>
                              {props.t("Vehicle Master")}
                            </Link> */}
                            <Link to="/CityMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-map me-2 text-primary"></i>
                              {props.t("City Master")}
                            </Link>

                            <Link to="/StateMaster" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-map-alt me-2 text-success"></i>
                              {props.t("State Master")}
                            </Link>
                            <Link to="/AssignDriver" className="dropdown-item" onClick={closeAllDropdowns}>
                              <i className="bx bx-rupee me-2 text-success"></i>
                              {props.t("Assign Driver")}
                            </Link>


                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(settools, toolsTimeout, setToolsTimeout)}
                  onMouseLeave={() => closeDropdown(settools, toolsTimeout, setToolsTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/UpdateGlobalOptions"
                  >
                    <i className="bx bx-transfer me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Tools")}
                    <div className="dropdown-arrow"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: tools })}
                    onMouseEnter={() => openDropdown(settools, toolsTimeout, setToolsTimeout)}
                    onMouseLeave={() => closeDropdown(settools, toolsTimeout, setToolsTimeout)}
                  >
                    <Link to="/UpdateGlobalOptions" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Update Global Options")}
                    </Link>
                  </div>
                </li>

                {/* <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setapproveordes, approveordesTimeout, setApproveordesTimeout)}
                  onMouseLeave={() => closeDropdown(setapproveordes, approveordesTimeout, setApproveordesTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/POApprovedByAdmin"
                  >
                    <i className="bx bx-transfer me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Approve Orders")}
                    <div className="dropdown-arrow"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: approveordes })}
                    onMouseEnter={() => openDropdown(setapproveordes, approveordesTimeout, setApproveordesTimeout)}
                    onMouseLeave={() => closeDropdown(setapproveordes, approveordesTimeout, setApproveordesTimeout)}
                  >
                    <Link to="/POApprovedByAdmin" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("PO Approval")}
                    </Link>
                    <Link to="/SOApprovedByAdmin" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("SO Approval")}
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(settransaction, transactionTimeout, setTransactionTimeout)}
                  onMouseLeave={() => closeDropdown(settransaction, transactionTimeout, setTransactionTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/PurchaseOrder"
                  >
                    <i className="bx bx-transfer me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Transaction")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: transaction })}
                    onMouseEnter={() => openDropdown(settransaction, transactionTimeout, setTransactionTimeout)}
                    onMouseLeave={() => closeDropdown(settransaction, transactionTimeout, setTransactionTimeout)}
                  >
                    <Link to="/PurchaseOrder" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Purchase Order")}
                    </Link>
                    <Link to="/SalesOrder" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Sales Order")}
                    </Link>
                    <Link to="/StockIn" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Purchase Entry")}
                    </Link>
                    <Link to="/Challan" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Delivery Challan")}
                    </Link>
                    <Link to="/Quotation" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Quotation")}
                    </Link>
                    <Link to="/WarehouseTransfer" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Warehouse Transfer")}
                    </Link>
                    <Link to="/ItemInspection" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Item Inspection")}
                    </Link>
                  </div>
                </li>
                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(settools, toolsTimeout, setToolsTimeout)}
                  onMouseLeave={() => closeDropdown(settools, toolsTimeout, setToolsTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/UpdateGlobalOptions"
                  >
                    <i className="bx bx-transfer me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Tools")}
                    <div className="dropdown-arrow"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: tools })}
                    onMouseEnter={() => openDropdown(settools, toolsTimeout, setToolsTimeout)}
                    onMouseLeave={() => closeDropdown(settools, toolsTimeout, setToolsTimeout)}
                  >
                    <Link to="/UpdateGlobalOptions" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-shopping-bag me-2 text-info"></i>
                      {props.t("Update Global Options")}
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setreports, reportsTimeout, setReportsTimeout)}
                  onMouseLeave={() => closeDropdown(setreports, reportsTimeout, setReportsTimeout)}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/Report_StockData"
                  >
                    <i className="bx bx-bar-chart-alt-2 me-2" style={{ fontSize: '1.2rem' }}></i>
                    {props.t("Reports")}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: reports })}
                    onMouseEnter={() => openDropdown(setreports, reportsTimeout, setReportsTimeout)}
                    onMouseLeave={() => closeDropdown(setreports, reportsTimeout, setReportsTimeout)}
                  >
                    <Link to="/Report_StockData" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-receipt me-2 text-primary"></i>
                      {props.t("Stock Data")}
                    </Link>
                    <Link to="/Report_DayBook" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-book me-2 text-success"></i>
                      {props.t("Day Book")}
                    </Link>
                    <Link to="/Report_GroupWise" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-gift me-2 text-warning"></i>
                      {props.t("Group Wise")}
                    </Link>
                   <Link to="/Report_StockPosition" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-gift me-2 text-warning"></i>
                      {props.t("Stock Position")}
                    </Link>
                     <Link to="/Report_StockPositionCompanyWise" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-gift me-2 text-warning"></i>
                      {props.t("Stock Position Company Wise")}
                    </Link>
                     <Link to="/stock-position-detail" className="dropdown-item" onClick={closeAllDropdowns}>
                      <i className="bx bx-gift me-2 text-warning"></i>
                      {props.t("Stock Position Detail")}
                    </Link>

                  </div>
                </li> */}

              </ul>
            </Collapse>

            {/* Right Side - Firm + Profile */}
            <div className="ms-auto d-flex align-items-center right-nav">
              <div className="firm-name-display d-flex align-items-center">
                <i className="bx bx-building me-2 firm-icon"></i>
                <span className="text-white fw-medium firm-text">
                  {(() => {
                    try {
                      const authUser = JSON.parse(localStorage.getItem("authUser"));
                      return authUser && authUser.FirmName
                        ? authUser.FirmName
                        : "Firm Name";
                    } catch (error) {
                      return "Firm Name";
                    }
                  })()}
                </span>
              </div>

              <div className="profile-menu-container">
                <ProfileMenu />
              </div>
            </div>

          </nav>
        </div>
      </div>
    </React.Fragment>

  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
